<template>
  <div style="margin-bottom: 100px">
    <div class="ui blue button"
         style="background-color: #092442"
         @click="showModal('package')"
         v-if="isAdmin()"
    >
      Add Package
    </div>
    <div class="ui blue button"
      style="background-color: #092442"
      @click="showModal('attach-items')"
      v-if="isAdmin() && useInventory"
    >
      Add Items
    </div>

    <h4 class="ui horizontal divider header">
      Open packages
    </h4>
    <abstractTable :columns="packageColumns" :data="openPackages()"
                  :classes="'ui tablet very compact center aligned celled table'"
                  v-if="openPackages().length">
      <template slot="table-column" v-if="useInventory">
        <th class="no-print"> {{ $t('actions') }} </th>
      </template>
      <template slot="table-row-after" slot-scope="props" v-if="useInventory">
        <td class="no-print">
          <div class="ui blue tiny button"
              style="background-color: #092442"
              @click="showPackageItems('show-package-items', props.row.id)">
            Show Items
          </div>
        </td>
      </template>
    </abstractTable>
    
    <h4 class="ui horizontal divider header">
      Closed packages
    </h4>
    <abstractTable :columns="packageColumns" :data="closedPackages()"
                  :classes="'ui tablet very compact center aligned celled table'"
                  v-if="closedPackages().length">
      <template slot="table-column" v-if="useInventory">
        <th class="no-print"> {{ $t('actions') }} </th>
      </template>
      <template slot="table-row-after" slot-scope="props" v-if="useInventory">
        <td class="no-print">
          <div class="ui blue tiny button"
              style="background-color: #092442"
              @click="showPackageItems('show-package-items', props.row.id)">
            Show Items
          </div>
        </td>
      </template>
    </abstractTable>

    <div class="ui large longer modal" id="package" style="margin-top: 20px !important;">
      <div class="header">New Package for {{ medicalMachine.name }}</div>
        <newPackage
          :object="medicalMachine"
          :apiURL="`medical_machines/${medicalMachine.id}/add/package`"
          :p="newPackage"
        />
    </div>

    <div class="ui modal" id="attach-items" style="margin-top: 20px !important;">
      <div class="header">Attach items to {{ medicalMachine.name }}</div>
      <div class="content"> 
        <div class="ui form" id="attach-items">
          <div class="field">
            <label for="reservation_type">Choose package</label>
            <select
              class="ui fluid search dropdown"
              id="packages-dropdown"
              v-model="formSelectedPackage"
              name="package"
            >
              <option value="">Choose Package</option>
              <option 
                :value="selectedPacakge.id" 
                v-for="selectedPacakge in medicalMachine.packages" 
                :key="selectedPacakge.id"
              >
                {{ selectedPacakge.name }}
              </option>
            </select>
          </div>
          <div class="field">
            <label for="reservation_type">Choose items</label>
            <select
              class="ui fluid search dropdown"
              id="items-dropdown"
              multiple="[]"
              v-model="selectedItems"
              name="items"
            >
              <option value="">Choose items</option>
              <option :value="item.id" v-for="item in items" :key="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="ui error message" v-if="selectedItemsErrors.length">
          <ul>
            <li v-for="(error, index) in selectedItemsErrors" :key="index">Test Error</li>
          </ul>
        </div> 
      </div>
      <div class="actions">
        <div
          class="ui blue right labeled icon button"
          style="background-color: #092442"
          @click="saveItems()"
        >
          <i class="right arrow icon"></i>
          Save
        </div>

      </div>
    </div>
   
    <div class="ui modal" id="show-package-items" style="margin-top: 20px !important;">
      <div class="header">{{ currentPackage.name }} items</div>
      <div class="content">
        <abstractTable :columns="itemsColumns" :data="computedItems()"
                      style="margin-bottom:50px"
                      :classes="'ui tablet very compact center aligned celled table'"
                      v-if="computedPackage().length"
                      :key="itemsKey">
          <template slot="table-column">
            <th class="no-print"> {{ $t('actions') }} </th>
          </template>
          <template slot="table-row-after" slot-scope="props">
            <td class="no-print">
              <div class="ui red tiny icon very compact button"
                  @click="removeItem(props.row.id.soldValue)">
                <i class="close icon"></i>
              </div>
            </td>
          </template>
        </abstractTable>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    newPackage: require('@/components/packages/NewPackage').default,
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    medicalMachine: { type: Object, required: true },
    items: { type: Array, required: true}
  },
  data() {
    return {
      newPackage: {
        name: '',
        unit_price: null,
        description: '',
        quantity: null,
        started_at: null,
        finished_at: null,
        unit_measurement_id: null,
        isGlobal: true
      },
      selectedItems: [],
      itemsKey: 0,
      formSelectedPackage: null,
      selectedItemsErrors: [],
      currentPackage: {},
    }
  },
  mounted () {
    this.initGUI()
  },
  computed: {
    useInventory() {
      return this.permissions.invetory_permissions.used
    },
    packageColumns () {
      return [
        { header: 'Id', fieldName: 'id', show: false },
        { header: 'Name', fieldName: 'name', show: true },
        { header: 'Description', fieldName: 'description', show: true },
        { header: 'Price', fieldName: 'unit_price', show: true },
        { header: 'Quantity', fieldName: 'quantity', show: true },
        { header: 'Unit measurement', fieldName: 'unitMeasurementName', show: true },
        { header: 'Started At', fieldName: 'started_at', show: true },
        { header: 'Finished At', fieldName: 'finished_at', show: true }
      ]
    },
    itemsColumns () {
      return [
        { header: 'Item Id', fieldName: 'id', show: true, html: true },
        { header: 'Name', fieldName: 'name', show: true },
        { header: 'Real Code', fieldName: 'real_code', show: true },
        { header: 'System Code', fieldName: 'system_code', show: true },
        { header: 'Quantity In Stock', fieldName: 'quantity_in_stock', show: true }
      ]
    }
  },
  methods: {
    computedPackage () {
      let formlatedPackages = []

      window._.each(this.medicalMachine.packages, selectedpackage => {
        formlatedPackages.push({
          id: selectedpackage.id,
          name: selectedpackage.name,
          description: selectedpackage.description,
          unit_price: this.formatPrice(selectedpackage.unit_price),
          quantity: selectedpackage.quantity,
          unitMeasurementName: this.unitMeasurements.find(selectedpackage.unit_measurement_id).name,
          started_at: selectedpackage.started_at
            ? window.moment(selectedpackage.started_at).format('DD/MM/YYYY - hh:mm a') : '-',
          finished_at: selectedpackage.finished_at
            ? window.moment(selectedpackage.finished_at).format('DD/MM/YYYY - hh:mm a') : '-'
        })
      })


      return formlatedPackages.sort((a,b) => {
        return b.id - a.id
      });
    },
    openPackages () {
      const currentOpenPackages = this.medicalMachine.packages.filter(p => !p.finished_at)
        .map(p => ({
          id: p.id,
          name: p.name,
          description: p.description,
          unit_price: this.formatPrice(p.unit_price),
          quantity: p.quantity,
          unitMeasurementName: this.unitMeasurements.find(p.unit_measurement_id).name,
          started_at: p.started_at
            ? window.moment(p.started_at).format('DD/MM/YYYY - hh:mm a') : '-',
          finished_at: p.finished_at
            ? window.moment(p.finished_at).format('DD/MM/YYYY - hh:mm a') : '-'
        })) 

      return currentOpenPackages.sort((a, b) => b.id - a.id)
    },
    closedPackages () {
      const currentOpenPackages = this.medicalMachine.packages.filter(p => p.finished_at)
        .map(p => ({
          id: p.id,
          name: p.name,
          description: p.description,
          unit_price: this.formatPrice(p.unit_price),
          quantity: p.quantity,
          unitMeasurementName: this.unitMeasurements.find(p.unit_measurement_id).name,
          started_at: p.started_at
            ? window.moment(p.started_at).format('DD/MM/YYYY - hh:mm a') : '-',
          finished_at: p.finished_at
            ? window.moment(p.finished_at).format('DD/MM/YYYY - hh:mm a') : '-'
        })) 

      return currentOpenPackages.sort((a, b) => b.id - a.id)
    },
    showPackageItems (modalName, packageId) {
      this.currentPackage = window._.find(this.medicalMachine.packages, selectedPackage => {
        return selectedPackage.id === packageId
      })

      this.showModal(modalName)
    },
    computedItems () {
      let formlatedItems = []

      const packageItemsIds = window._.filter(this.medicalMachine.medical_machine_items, medicalMachinePackageItem => {
        return medicalMachinePackageItem.package_id === this.currentPackage.id
      }).map(packageItem => packageItem.item_id)

      const completeItems = window._.filter(this.items, item => {
        return packageItemsIds.includes(item.id)
      })

      window._.each(completeItems, item => {
        formlatedItems.push({
          id: {
            functionality: () => {
              this.navigateTo('Show_Item', { key: 'params', value: { id: item.id } })
            },
            value: `<a style="cursor: pointer; text-decoration:underline;">${item.id}</a>`,
            soldValue: item.id
          },
          name: item.name || '-',
          real_code: item.real_code || '-',
          system_code: this.displaySystemCode(item.system_code) || '-',
          quantity_in_stock: item.quantity_in_stock || '-'
        })
      })

      return formlatedItems
    },
    initPackage () {
      this.newPackage = {
        name: '',
        unit_price: null,
        description: '',
        quantity: null,
        started_at: null,
        finished_at: null
      }
    },
    showModal (modalId) {
      $('#'+ modalId).modal({
        onHidden: () => {
          this.initPackage()
        },
        onShow: () => {
          this.initGUI()
        }
      }).modal('show').modal('refresh')
      this.initGUI()
    },
    hideModal (modalId) {
      $('#' + modalId).modal('hide')
    },
    initGUI () {
      this.$nextTick(() => {
        $('#start-at').calendar({
          type: 'datetime',
          minDate: new Date(),
          onChange: (date) => {
            this.newPackage.started_at = date
          }
        })

        $('#finish-at').calendar({
          type: 'datetime',
          minDate: this.newPackage.start_at,
          onChange: (date) => {
            this.newPackage.finished_at = date
          }
        })

        $('#items-dropdown').dropdown();
        $('#items-dropdown').dropdown('set selected', this.selectedItems);

        $('#unit-measurement-search').dropdown();
      })
    },
    saveItems () {
      if (this.formSelectedPackage) {
        this.$http.post(`medical_machines/${this.$route.params.id}/add/items`, {
          items: {
            medical_machine_id: this.$route.params.id,
            item_ids: this.selectedItems,
            package_id: this.formSelectedPackage
          },
          clinic_id: this.getFromLocalStorage('clinicId')
        }).then(response => {
          const packages = this.medicalMachine.packages
          this.medicalMachine = response.data
          this.medicalMachine.album = { images: [] }
          this.medicalMachine.packages = packages
          this.hideModal('attach-items')
          ++this.itemsKey
          this.selectedItems = []
          this.formSelectedPackage = null
        })
      } else {
        this.selectedItemsErrors.push('Please, select a package.')
      }
    },
    removeItem (itemId) {
      this.$http.post(`medical_machines/${this.$route.params.id}/remove/items`, {
        medical_machine_id: this.$route.params.id,
        item_id: itemId,
        package_id: this.currentPackage.id,
        clinic_id: this.getFromLocalStorage('clinicId')
      }).then(response => {
        const packages = this.medicalMachine.packages
        this.medicalMachine = response.data
        this.medicalMachine.album = { images: [] }
        this.medicalMachine.packages = packages
        this.currentPackage = window._.find(this.medicalMachine.packages, selectedPackage => {
          return selectedPackage.id === this.currentPackage.id
        })
        this.selectedItems = []
        ++this.itemsKey
      })
    },
    displaySystemCode (code) {
      if (code && code.length < 3) {
        return '0'.repeat(3 - code.length) + code
      }
      return code || '-'
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/medical_machines/medical_machine_components/details_components/Packages.vue